import { Button, FormControl, FormControlLabel, InputAdornment, OutlinedInput, Radio, RadioGroup, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import RangeSlider from 'src/components/property/RangeSlider';
import HelpCenterButton from 'src/components/shared/HelpCenterButton';
import { VACANT_UNIT_USAGE } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import useStyles from './styles';
import { VacantUnitOccupantsSelector } from 'src/components/property/VacantUnitOccupantsSelector';
const VacantUnitBillsContent = observer(_ref => {
  let handleSave = _ref.handleSave,
    utility = _ref.utility;
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const setVacantUnitUsage = store.addNewProperty.setVacantUnitUsage;
  const setVacantUnitUsageLimit = store.addNewProperty.setVacantUnitUsageLimit;
  const vacantUnitUsage = store.addNewProperty.vacantUnitUsage.get(utility.utilityId) || utility.vacantUnitUsage || utility.defaultVacantUnitUsage || VACANT_UNIT_USAGE.NoUsage;
  const defaultValue = utility.defaultVacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? 30 : undefined;
  const vacantUnitUsageLimit = store.addNewProperty.vacantUnitUsageLimit.get(utility.utilityId) || defaultValue || utility.vacantUnitUsageLimit;
  const isDisabled = vacantUnitUsage !== VACANT_UNIT_USAGE.LimitedUsage;
  const setVacantUnitOccupantsCount = store.addNewProperty.setVacantUnitOccupantsCount;
  const vacantUnitOccupantsCount = store.addNewProperty.vacantUnitOccupantsCount.get(utility.utilityId) || utility.vacantUnitOccupantsCount || 1;
  useEffect(() => {
    setVacantUnitUsage(utility.utilityId, utility.vacantUnitUsage || utility.defaultVacantUnitUsage || VACANT_UNIT_USAGE.NoUsage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const levels = [{
    key: VACANT_UNIT_USAGE.NormalUsage,
    label: t('add_new_property_flow.full_usage'),
    text: t('add_new_property_flow.full_usage_text')
  }, {
    hasInput: true,
    key: VACANT_UNIT_USAGE.LimitedUsage,
    label: t('add_new_property_flow.unit_usage_limited_usage'),
    text: t('add_new_property_flow.limited_usage_text')
  }, {
    key: VACANT_UNIT_USAGE.NoUsage,
    label: t('add_new_property_flow.no_usage'),
    text: t('add_new_property_flow.no_usage_text')
  }];
  const handleChange = (event, value) => setVacantUnitUsageLimit(utility.utilityId, value);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.level_of_usage')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.level_of_usage_text')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    onChange: e => setVacantUnitUsage(utility.utilityId, e.target.value),
    value: vacantUnitUsage
  }, levels.map(level => /*#__PURE__*/React.createElement("div", {
    onClick: () => setVacantUnitUsage(utility.utilityId, level.key)
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Radio, null),
    key: level.key,
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, level.label),
    value: level.key
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, level.text), level.key === VACANT_UNIT_USAGE.NormalUsage && /*#__PURE__*/React.createElement(VacantUnitOccupantsSelector, {
    allocationMethod: utility.allocationMethod,
    onChange: value => setVacantUnitOccupantsCount(utility.utilityId, value),
    vacantUnitUsage: vacantUnitUsage,
    value: vacantUnitOccupantsCount
  }), level.hasInput && /*#__PURE__*/React.createElement("div", {
    className: classes.sliderWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.slider
  }, /*#__PURE__*/React.createElement(RangeSlider, {
    isDisabled: isDisabled,
    labelFormat: "percentage",
    handleChange: handleChange,
    maxValue: 90,
    minValue: 10,
    stepValue: 5,
    value: vacantUnitUsageLimit
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.input
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: true,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, "%"),
    id: "vacantUnitUsageLimit",
    type: "number",
    value: vacantUnitUsageLimit
  })))))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(HelpCenterButton, null)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.footerButton, " ").concat(modalFooterClasses.modalFooter)
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: event => handleSave(event, {
      vacantUnitUsage,
      vacantUnitUsageLimit,
      vacantUnitOccupantsCount
    }),
    variant: "contained",
    'custom-attribute': '219-VacantUnitBills'
  }, t('add_new_property_flow.save_and_close'))));
});
export default VacantUnitBillsContent;